/*
    Create by Pierre Marsot on 05/12/2017
*/
import {get, removeApi, postApi} from '../tools/api';
import {sendMessageError} from './toast';

export const LOAD_BALISES_SUCCESS = 'LOAD_BALISES_SUCCESS';
export const LOAD_BALISES_ERROR = 'LOAD_BALISES_ERROR';

export const REMOVE_BALISES_SUCCESS = 'REMOVE_BALISES_SUCCESS';
export const REMOVE_BALISES_ERROR = 'REMOVE_BALISES_ERROR';

export const ADD_BALISE_SUCCESS = 'ADD_BALISE_SUCCESS';
export const ADD_BALISE_ERROR = 'ADD_BALISE_ERROR';

function loadBalisesSuccess(payload) {
    return {
        type: LOAD_BALISES_SUCCESS,
        balises: payload.balises,
    };
}

function loadBalisesError() {
    return {
        type: LOAD_BALISES_ERROR,
    };
}

export function loadBalises(offset) {
    return dispatch => {
        get('/api/societe/balises', {
            offset: offset,
            prefix: '',
            type_recherche: '1',
        })
            .then((response) => {
                if (response && response.balises) {
                    return dispatch(loadBalisesSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_recuperation_balises"));
                    return dispatch(loadBalisesError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(loadBalisesError());
            });
    }
}

function removeBaliseSuccess(idBalise) {
    return {
        type: REMOVE_BALISES_SUCCESS,
        id_balise: idBalise,
    };
}

function removeBaliseError() {
    return {
        type: REMOVE_BALISES_ERROR,
    };
}

export function removeBalise(idBalise) {
    return dispatch => {
        removeApi('/api/societe/balises/' + idBalise)
            .then(() => {
                return dispatch(removeBaliseSuccess(idBalise));
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(removeBaliseError());
            });
    }
}

function addBaliseSuccess(payload) {
    return {
        type: ADD_BALISE_SUCCESS,
        balise: payload.balise,
    }
}

function addBaliseError() {
    return {
        type: ADD_BALISE_ERROR,
    };
}

export function addBalise(numeroDeSerie, deveui, appkey, appeui) {
    return dispatch => {
        if(!numeroDeSerie || numeroDeSerie.length === 0) {
            dispatch(sendMessageError("erreur_numero_de_serie"));
            return dispatch(addBaliseError());
        }

        if(!deveui || deveui.length === 0) {
            dispatch(sendMessageError("erreur_deveui"));
            return dispatch(addBaliseError());
        }

        if(!appkey || appkey.length === 0) {
            dispatch(sendMessageError("erreur_appkey"));
            return dispatch(addBaliseError());
        }

        if(!appeui || appeui.length === 0) {
            dispatch(sendMessageError("erreur_appeui"));
            return dispatch(addBaliseError());
        }

        postApi('/api/societe/balises', {
            _source: {
                numero_serie: numeroDeSerie,
                lora_settings: {
                    deveui: deveui,
                    appeui: appeui,
                    appkey: appkey,
                }
            }
        })
            .then((response) => {
                if (response && response.balise) {
                    return dispatch(addBaliseSuccess(response));
                } else {
                    dispatch(sendMessageError("erreur_add_balise"));
                    return dispatch(addBaliseError());
                }
            })
            .catch((response) => {
                if (response && response.error) {
                    dispatch(sendMessageError(response.error));
                }
                return dispatch(addBaliseError());
            });
    }
}

export function associerUsersBalise(idBalise, users) {
    return new Promise((resolve, reject) => {
        //Création de l'objet JSON à envoyer
        let detailUsersAssocieBalise = [];

        for(const user of users) {
            detailUsersAssocieBalise.push({
                id_user: user._id,
                is_administrator: user.isAdministrateur,
            })
        }

        postApi("/api/societe/users/add/balise", {
            id_balise: idBalise,
            detail_users_associe_balise: detailUsersAssocieBalise
        })
            .then(() => {
                return resolve();
            })
            .catch((response) => {
                if (response && response.error) {
                    return reject(response.error);
                } else {
                    return reject("erreur_association_utilisateurs_balise");
                }
            });
    });
}

export function countBalises() {
    return new Promise((resolve, reject) => {
        get("/api/societe/balises/count")
            .then((response) => {
                if (response && response.count) {
                    return resolve(response.count);
                }
                return reject();
            })
            .catch((response) => {
                if (response && response.error) {
                    return reject(response.error);
                }
                return reject("");
            });
    });
}

export function associerAdministrateurBalise(idBalise, idUser) {
    return new Promise((resolve, reject) => {
       postApi('/api/societe/balises/administrator', {
           id_user: idUser,
           id_balise: idBalise
       })
           .then(response => {
               return resolve();
           })
           .catch((response) => {
               if (response && response.error) {
                   return reject(response.error);
               }
               return reject("erreur_inconnue");
           });
    });
}


// WEBPACK FOOTER //
// ./src/actions/balises.js